// useMobilePlatform.ts
import { useEffect, useState } from "react";

// type MobilePlatform = "ios" | "android" | null;
// 
// export function useMobilePlatform(): MobilePlatform {
//   const [platform, setPlatform] = useState<MobilePlatform>(null);

export function useMobilePlatform() {
  const [platform, setPlatform] = useState(null);

  useEffect(() => {
    if (typeof navigator === "undefined") return;

    const ua = navigator.userAgent || navigator.vendor || (window || {}).opera || "";

    const isAndroid = /Android/i.test(ua);
    const isIOS = /iPhone|iPad|iPod/i.test(ua);

    if (isAndroid) setPlatform("android");
    else if (isIOS) setPlatform("ios");
    else setPlatform(null);
  }, []);

  return platform;
}

